import React from 'react'

const Facebook = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="31"
      height="31"
      viewBox="0 0 31 31"
    >
      <g>
        <g>
          <path
            className="outer-path"
            fill="#939393"
            d="M15.335 30.67c8.47 0 15.335-6.866 15.335-15.335C30.67 6.865 23.804 0 15.335 0 6.865 0 0 6.866 0 15.335c0 8.47 6.866 15.335 15.335 15.335z"
          />
        </g>
        <g>
          <path
            fill="#fff"
            d="M19.082 15.98h-2.739v10.077h-4.15V15.979H10.22v-3.542h1.974v-2.292c0-1.639.775-4.205 4.186-4.205l3.074.013V9.39h-2.23c-.366 0-.88.183-.88.965v2.085h3.1z"
          />
        </g>
      </g>
    </svg>
  )
}

export default Facebook
